import { render, staticRenderFns } from "./BillingsListTable.vue?vue&type=template&id=6706523b"
import script from "./BillingsListTable.vue?vue&type=script&lang=js"
export * from "./BillingsListTable.vue?vue&type=script&lang=js"
import style0 from "./BillingsListTable.vue?vue&type=style&index=0&id=6706523b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports